// src/services/performerApi.ts
import axios, { type AxiosResponse } from 'axios';
import authService from './authService';
import { getApiBaseUrl } from './apiConfig';

export interface PerformerRecord {
  id: string;
  name: string;
  email?: string | null;
  isVerified?: boolean;
  isPublic?: boolean;
  tenantId?: string | null;
  managedEntityId?: string | null;
  parentEntityId?: string | null;
  currencyName?: string | null;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  isLinked?: boolean;
  isFollowing?: boolean;
  connectionStatus?: 'pending' | 'accepted';
  profilePicture?: string | null;
  bio?: string | null;
  genres?: string[] | null;
  socialLinks?: Record<string, string> | any[] | null;
  customLinks?: Array<Record<string, any>> | null;
  /** Off-platform merch store (issue #43), validated http(s) by the server. */
  merchUrl?: string | null;
  upcomingEvents?: any[];
}

const API_BASE = `${getApiBaseUrl()}/api/performers`;

const withAuth = () => ({ headers: authService.getAuthHeader() });

export const performerApi = {
  async list(params: { managedEntityId?: string; searchTerm?: string; limit?: number; offset?: number; isActive?: boolean; isVerified?: boolean; scope?: 'global' | 'network' | 'local' } = {}): Promise<PerformerRecord[]> {
    const res: AxiosResponse<PerformerRecord[]> = await axios.get(API_BASE, {
      params,
      ...withAuth(),
    });
    return res.data;
  },



  async listLocal(params: { term?: string; limit?: number; offset?: number; managedEntityId?: string } = {}): Promise<PerformerRecord[]> {
    const res: AxiosResponse<PerformerRecord[]> = await axios.get(`${API_BASE}/local`, {
      params,
      ...withAuth(),
    });
    return res.data;
  },

  async createLocal(input: { name: string; email?: string; currencyName?: string; parentEntityId?: string }): Promise<PerformerRecord> {
    const res: AxiosResponse<PerformerRecord> = await axios.post(`${API_BASE}/local`, input, withAuth());
    return res.data;
  },

  async update(id: string, patch: Partial<PerformerRecord>): Promise<PerformerRecord> {
    const res: AxiosResponse<PerformerRecord> = await axios.put(`${API_BASE}/${id}`, patch, withAuth());
    return res.data;
  },

  async getMyPerformers(): Promise<PerformerRecord[]> {
    const res: AxiosResponse<PerformerRecord[]> = await axios.get(`${API_BASE}/my-performers`, withAuth());
    return res.data;
  },

  async getPerformer(id: string): Promise<PerformerRecord> {
    const res: AxiosResponse<PerformerRecord> = await axios.get(`${API_BASE}/${id}`);
    return res.data;
  },
};

export default performerApi;
